import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { SettingService } from "./setting.service";
import { Settings } from "./settings";

@Injectable({ providedIn: 'root' })
export class SettingsHttpService {

    constructor(private http: HttpClient, private settingsService: SettingService) {
    }

    initializeApp(): Promise<any> {

        return new Promise(
            (resolve) => {
                this.http.get('assets/settings.json')
                    .toPromise()
                    .then(response => {
                        this.settingsService.settings = <Settings>response;
                        resolve();
                        
                    }
                    )
            }
        );
    }
}